import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import MainLayout from "./layout/MainLayout";
import Home from "./Home";
import About from "./pages/About";
import IndivisualVilla from "./pages/Residential/IndivisualVilla";
import ResidentialAppartment from "./pages/Residential/ResidentialAppartment";
import Hospital from "./pages/Comercial/Hospital";
import OfficeList from "./pages/Comercial/OfficeList";
import HotelLift from "./pages/Comercial/HotelLift";
import ItPark from "./pages/Comercial/ItPark";
import MallRetail from "./pages/Comercial/MallRetail";
import Factory from "./pages/Comercial/Factory";
import Escalators from "./pages/Escalators";
import CabinDesign from "./pages/Products/CabinDesign";
import Door from "./pages/Products/Door";
import Machin from "./pages/Products/Machin";
import ControlPanel from "./pages/Products/ControlPanel";
import OperatingPanel from "./pages/Products/OperatingPanel";
import Drawing from "./pages/Products/Drawing";
import Service from "./pages/Service";
import Media from "./pages/Media";
import GovProject from "./pages/PRESTIGIOUS CLIENTS/GovProject";
import PrivateProject from "./pages/PRESTIGIOUS CLIENTS/PrivateProject";
import Career from "./pages/Career";
import Contact from "./pages/Contact";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/elevators/residential/villas" element={<IndivisualVilla/>}/>
          <Route path="/elevators/residential/apartment" element={<ResidentialAppartment/>}/>
          <Route path="/elevators/commercial/hospital" element={<Hospital/>}/>
          <Route path="/elevators/commercial/office" element={<OfficeList/>}/>
          <Route path="/elevators/commercial/hotel" element={<HotelLift/>}/>
          <Route path="/elevators/commercial/itpark" element={<ItPark/>}/>
          <Route path="/elevators/commercial/malls" element={<MallRetail/>}/>
          <Route path="/elevators/commercial/factory" element={<Factory/>}/>
          <Route path="/escalators" element={<Escalators/>}/>
          <Route path="/products/cabin" element={<CabinDesign />} />
          <Route path="/products/door" element={<Door />} />
          <Route path="/products/machine" element={<Machin />} />
          <Route path="/products/control-panel" element={<ControlPanel />} />
          <Route path="/products/operating-panel" element={<OperatingPanel />} />
          <Route path="/products/drawing" element={<Drawing />} />
          <Route path="/services" element={<Service />} />
          <Route path="/media" element={<Media />} />
          <Route path="/clients/government" element={<GovProject />} />
          <Route path="/clients/private" element={<PrivateProject />} />
          <Route path="/career" element={<Career />} />
          <Route path="/contact" element={<Contact />} />

        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
